import { defineMessages, IntlShape } from '@redbubble/next/intl';
import { CarouselMediaCardProps } from 'components/CarouselSection/types';
import {
  LicensedProduct,
  ListsButtonInventoryItem,
  ListsInclusions,
} from '../../../../types/shop-bff/types';
import { getPreviewUrl } from '../../../../utils/common';
import { PreviewStyle } from '../../constants';
import { PriceProps } from '../ProductStyleSwitcher/ProductStyleSelectorItem';

const messages = defineMessages({
  byArtist: {
    defaultMessage: 'By {artistName}',
  },
});

export const mapLicensedProductMediaCardProps = (
  listsInclusions: ListsInclusions | null
) => {
  return (
    inputData: LicensedProduct,
    intl: IntlShape
  ): CarouselMediaCardProps | null => {
    // TODO: When IHS schema updates, remove nullish option
    const artistName =
      inputData?.inventoryItem?.work.artistShopDisplayName ?? undefined;
    return {
      productId: inputData?.inventoryItemId,
      link: inputData?.inventoryItem?.productPageUrl || '',
      imageSrc: getPreviewUrl(
        inputData?.inventoryItem,
        PreviewStyle.CLOSE_PREVIEW
      ),
      title: `${inputData?.inventoryItem?.work.title || ''} ${
        inputData?.inventoryItem?.description || ''
      }`,
      workTitle: inputData?.inventoryItem?.work.title || '',
      artistName,
      matureContent: inputData?.inventoryItem?.work.matureContent ?? false,
      caption: intl.formatMessage(messages.byArtist, {
        artistName,
      }),
      loading: false,
      testId: `licensed-products-card`,
      addToListButtonProps: {
        inventoryItem: inputData?.inventoryItem as ListsButtonInventoryItem,
        workId: inputData?.inventoryItem?.work.id || '',
        listsInclusions,
      },
      // Show in-stock when status is unknown, this is inline with IHS backwards compatibility
      stockStatus: inputData?.inventoryItem?.stockStatus || {
        status: 'in-stock',
      },
    };
  };
};

export const mapLicensedProductPriceProps = (
  inputData: LicensedProduct
): PriceProps | null => {
  if (!inputData?.inventoryItem?.price) return null;

  const { discount, currency, amount } = inputData.inventoryItem.price;

  return {
    discount: { amount: discount.amount, percent: discount.percent },
    currency,
    amount,
  };
};
